"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachSyntheticRecords = void 0;
const common_1 = require("@finley-technologies/common");
const typeguards = __importStar(require("../typeguards"));
const syntheticOrder_1 = require("./syntheticOrder");
const attachSyntheticRecords = (dbGraph) => {
    const finalDbGraph = (0, syntheticOrder_1.toDb)(dbGraph);
    for (const finalDataTape of finalDbGraph.dataTapes) {
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderRecordDB(common_1.utils.stripDbTimeStamps(finalDataTape)), new common_1.error.FinleyError(`[${finalDataTape.id}] is invalid tapeBuilder DB record while attaching synthetic`, {
            metadata: {
                logMeta: {
                    errorTape: JSON.stringify(finalDataTape),
                },
            },
        }));
    }
    return finalDbGraph;
};
exports.attachSyntheticRecords = attachSyntheticRecords;
//# sourceMappingURL=attach.js.map